import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material/material.module';
import { NgxMaskModule } from 'ngx-mask';
import { InstitutionSearchDialog } from './component/institution-search/institution-search.component';
import { PersonAddress } from './component/address/person-address.component';
import { PersonEmail } from './component/email/person-email.component';
import { PersonPhone } from './component/phone/person-phone.component';
import { AuditTrailComponent } from './component/audit-trail/audit-trail.component';


@NgModule({
    imports: [   
        CommonModule, 
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDatepickerModule, 
        MatMomentDateModule,
        NgxMaskModule.forRoot()
       ],
    exports: [InstitutionSearchDialog,PersonAddress, PersonEmail, PersonPhone, AuditTrailComponent],
    declarations: [
       InstitutionSearchDialog,
       PersonAddress,
       PersonEmail,
       PersonPhone,
       AuditTrailComponent
    ],
    providers: [],
})
export class SharedModule { }
